import React from 'react';
import Header from '../components/header/Header.jsx';
import Footer from '../components/footer/Footer.jsx';
import FixedPlugin from '../components/fixedPlugin/FixedPlugin';

const About = () => {
    return (
        <div className='min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-white '>
            <FixedPlugin />
            <Header />
            <main className='mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8'>
                <div className='grid grid-cols-1 md:grid-cols-[7fr_3fr] gap-12 items-center'>
                    {/* Left Column - Content */}
                    <div className='space-y-8'>
                        <div>
                            <h1 className='text-4xl font-bold mb-6'>
                                ABOUT<br />
                                VALUEPAY.AI
                            </h1>
                            <p className='text-lg text-gray-700 dark:text-gray-300 leading-relaxed'>
                                ValuePay ai is an innovative Generative AI (GenAI) platform designed to revolutionise construction valuation reporting. Developed under HASNOVA Technologies Limited, ValuePay ai integrates extended reality (XR) and advanced AI into one unified application.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-xl font-semibold mb-4 opacity-95'>
                                The process is simple yet powerful:
                            </h2>
                            <ul className='space-y-2 ml-4 list-disc text-gray-700 dark:text-gray-300'>
                                <li>
                                    Download the ValuePay ai mobile application.
                                </li>
                                <li>
                                    Upload your project's Bill of Quantities (BOQ using dots, direct lines, or area/volume inputs (m, m², m³).
                                </li>
                                <li>
                                    Sync the quantities to our web interface, where our AI instantly generates accurate interim valuation reports.
                                </li>
                                <li>
                                    Access a ready-to-use payment notice template for streamlined financial workflows.
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Right Column - Image */}
                    <div className='flex justify-center md:justify-end'>
                        <div className='w-80 h-96 bg-gray-50 dark:bg-gray-800/50 rounded-lg flex items-center justify-center'>
                            <div className='text-center text-gray-500 dark:text-gray-400'>
                                <div className='w-24 h-24 bg-gray-300 dark:bg-gray-800/90 rounded-full mx-auto mb-4 flex items-center justify-center'>
                                    <svg className='w-12 h-12' fill='currentColor' viewBox='0 0 20 20'>
                                        <path fillRule='evenodd' d='M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z' clipRule='evenodd' />
                                    </svg>
                                </div>
                                <p className='text-sm'>Professional Image Placeholder</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mission and Vision Section */}
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 mt-16'>
                    {/* Our Mission */}
                    <div className='bg-gray-50 dark:bg-gray-800/50 border border-gray-800/40 dark:border-gray-600/25 p-8 rounded-lg'>
                        <h2 className='text-2xl font-bold mb-6 opacity-95'>OUR MISSION</h2>
                        <div className='space-y-4 text-gray-700 dark:text-gray-300'>
                            <p>
                                At ValuePay ai, our <strong>mission</strong> is simple but bold:
                            </p>
                            <p>
                                To enhance global productivity in construction payments by leveraging cutting-edge extended reality and generative AI.
                            </p>
                            <p>
                                We empower professionals to make faster, smarter, and more transparent decisions by delivering real-time interim valuation reports that improve accuracy and accountability across the supply-chain.
                            </p>
                        </div>
                    </div>

                    {/* Our Vision */}
                    <div className='bg-gray-50 dark:bg-gray-800/50 border border-gray-800/40 dark:border-gray-600/25 p-8 rounded-lg'>
                        <h2 className='text-2xl font-bold mb-6 opacity-95'>OUR VISION</h2>
                        <div className='space-y-4 text-gray-700 dark:text-gray-300'>
                            <p>
                                We envision a future where construction and quantity surveying processes are digitally transformed and globally connected.
                            </p>
                            <p>
                                By embedding XR and GenAI into core workflows, we strive to:
                            </p>
                            <ul className='space-y-2 ml-4 list-disc'>
                                <li>
                                    Create measurable efficiencies in construction management.
                                </li>
                                <li>
                                    Reduce delays in interim payments.
                                </li>
                                <li>
                                    Foster greater trust and transparency between clients, contractors, and stakeholders.
                                </li>
                                <li>
                                    Set new global benchmarks for accuracy, speed, and innovation in valuation reporting.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* About HASNOVA Technologies */}
                <div className='mt-16 dark:bg-gray-800/50 p-8 rounded-lg border border-gray-800/40 dark:border-gray-600/25'>
                    <h2 className='text-2xl font-bold mb-6 opacity-95'>ABOUT HASNOVA TECHNOLOGIES LIMITED</h2>
                    <p className='text-gray-700 dark:text-gray-300 leading-relaxed mb-6'>
                        HASNOVA Technologies Limited is a forward-thinking technology company dedicated to building intelligent, innovative, and sustainable solutions that bridge the gap between traditional industry practices and cutting-edge technological advancement.
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default About;
